import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { contactInfoApi } from '../../services/adminApi';

const ContactInfoForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [formData, setFormData] = useState({
    type: 'phone',
    title: '',
    value: '',
    is_active: 1,
    sort_order: 0
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (isEdit) {
      fetchContactInfo();
    }
  }, [id, isEdit]);

  const fetchContactInfo = async () => {
    try {
      setLoading(true);
      const response = await contactInfoApi.getById(id);
      if (response.data.success) {
        setFormData(response.data.data);
      }
    } catch (err) {
      console.error('Contact info fetch error:', err);
      setError('İletişim bilgisi yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      if (isEdit) {
        await contactInfoApi.update(id, formData);
        setSuccess('İletişim bilgisi başarıyla güncellendi');
      } else {
        await contactInfoApi.create(formData);
        setSuccess('İletişim bilgisi başarıyla oluşturuldu');
      }

      setTimeout(() => {
        navigate('/admin/contact-info');
      }, 1500);
    } catch (err) {
      console.error('Submit error:', err);
      setError(err.response?.data?.message || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const headerCardStyle = {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    borderRadius: '0.75rem',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    color: 'white',
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  };

  const formCardStyle = {
    backgroundColor: 'white',
    borderRadius: '0.75rem',
    padding: '2rem',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
  };

  const formGroupStyle = {
    marginBottom: '1.5rem'
  };

  const labelStyle = {
    display: 'block',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '0.5rem'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem',
    border: '1px solid #d1d5db',
    borderRadius: '0.5rem',
    fontSize: '0.875rem',
    color: '#374151',
    backgroundColor: 'white',
    transition: 'all 0.2s',
    boxSizing: 'border-box'
  };

  const selectStyle = {
    ...inputStyle,
    cursor: 'pointer'
  };

  const textareaStyle = {
    ...inputStyle,
    minHeight: '100px',
    resize: 'vertical'
  };

  const checkboxContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  };

  const checkboxStyle = {
    width: '1rem',
    height: '1rem',
    cursor: 'pointer'
  };

  const buttonStyle = {
    backgroundColor: '#3b82f6',
    color: 'white',
    padding: '0.75rem 1.5rem',
    borderRadius: '0.5rem',
    border: 'none',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    marginRight: '0.75rem'
  };

  const cancelButtonStyle = {
    backgroundColor: '#6b7280',
    color: 'white',
    padding: '0.75rem 1.5rem',
    borderRadius: '0.5rem',
    border: 'none',
    fontSize: '0.875rem',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    textDecoration: 'none',
    display: 'inline-block'
  };

  const errorStyle = {
    backgroundColor: '#fee2e2',
    border: '1px solid #fecaca',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginBottom: '1rem',
    color: '#dc2626',
    fontSize: '0.875rem'
  };

  const successStyle = {
    backgroundColor: '#dcfce7',
    border: '1px solid #bbf7d0',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginBottom: '1rem',
    color: '#166534',
    fontSize: '0.875rem'
  };

  const loadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3rem',
    fontSize: '1rem',
    color: '#6b7280'
  };

  const typeOptions = [
    { value: 'phone', label: '📞 Telefon' },
    { value: 'email', label: '📧 E-posta' },
    { value: 'address', label: '📍 Adres' },
    { value: 'social', label: '🌐 Sosyal Medya' }
  ];

  if (loading && isEdit) {
    return (
      <div style={loadingStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <div style={{
            width: '1rem',
            height: '1rem',
            border: '2px solid #e5e7eb',
            borderTop: '2px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          İletişim bilgisi yükleniyor...
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem' }}>
      <div style={headerCardStyle}>
        <div>
          <h1 style={{ margin: '0 0 0.5rem 0', fontSize: '1.875rem', fontWeight: '700' }}>
            {isEdit ? 'İletişim Bilgisi Düzenle' : 'Yeni İletişim Bilgisi'}
          </h1>
          <p style={{ margin: 0, opacity: 0.9 }}>
            {isEdit ? 'İletişim bilgisini düzenleyin' : 'Yeni iletişim bilgisi ekleyin'}
          </p>
        </div>
      </div>

      {error && (
        <div style={errorStyle}>
          ⚠️ {error}
        </div>
      )}

      {success && (
        <div style={successStyle}>
          ✅ {success}
        </div>
      )}

      <div style={formCardStyle}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={formGroupStyle}>
              <label htmlFor="type" style={labelStyle}>
                Tip *
              </label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleChange}
                style={selectStyle}
                required
              >
                {typeOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div style={formGroupStyle}>
              <label htmlFor="title" style={labelStyle}>
                Başlık *
              </label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                style={inputStyle}
                placeholder="Örn: Ana Telefon"
                required
              />
            </div>
          </div>

          <div style={formGroupStyle}>
            <label htmlFor="value" style={labelStyle}>
              Değer *
            </label>
            <textarea
              id="value"
              name="value"
              value={formData.value}
              onChange={handleChange}
              style={textareaStyle}
              placeholder="İletişim bilgisinin değerini girin..."
              required
            />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
            <div style={formGroupStyle}>
              <label htmlFor="sort_order" style={labelStyle}>
                Sıralama
              </label>
              <input
                type="number"
                id="sort_order"
                name="sort_order"
                value={formData.sort_order}
                onChange={handleChange}
                style={inputStyle}
                placeholder="0"
                min="0"
              />
            </div>

            <div style={formGroupStyle}>
              <div style={checkboxContainerStyle}>
                <input
                  type="checkbox"
                  id="is_active"
                  name="is_active"
                  checked={formData.is_active === 1}
                  onChange={handleChange}
                  style={checkboxStyle}
                />
                <label htmlFor="is_active" style={labelStyle}>
                  Aktif
                </label>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2rem' }}>
            <button
              type="button"
              onClick={() => navigate('/admin/contact-info')}
              style={cancelButtonStyle}
              onMouseOver={(e) => e.target.style.backgroundColor = '#4b5563'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#6b7280'}
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                ...buttonStyle,
                opacity: loading ? 0.6 : 1,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
              onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#2563eb')}
              onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#3b82f6')}
            >
              {loading ? 'Kaydediliyor...' : (isEdit ? 'Güncelle' : 'Oluştur')}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        input:focus, select:focus, textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
      `}</style>
    </div>
  );
};

export default ContactInfoForm;
